export const LIMITED_SCOPE = 'surveyjunkie.users.limited.self';
export const FULL_SCOPE = 'surveyjunkie.users.manage.self';
